module.exports = __webpack_public_path__ + "img/1-tr.a65d1a39.jpg";